import React, { useState } from 'react';
import { Col, Tooltip } from 'reactstrap';

const TechnologyItem = ({ color, name, iconClassName }) => {
  const [tooltipOpen, setToolTipOpen] = useState(false);

  const toggle = () => setToolTipOpen(!tooltipOpen);
  return (
    <Col className='mb-3' sm={3}>
      <span
        className={`${color} shadow text-center h1 d-block`}
        id={`${name}Tooltip`}>
        <i className={`${iconClassName}`}></i>
      </span>
      <Tooltip
        placement='top'
        isOpen={tooltipOpen}
        toggle={toggle}
        target={`${name}Tooltip`}>
        {name}
      </Tooltip>
    </Col>
  );
};

export default TechnologyItem;
